import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationHandlerService } from '../../core/configuration-handler.service';
import { SEOService } from '../../core/seo.service';
import { DiscoveryComponent } from '../discovery.component';

@Component({
    selector: 'esp-discovery-standalone',
    templateUrl: './discovery-standalone.component.html',
    styleUrls: ['./discovery-standalone.component.scss'],
    imports: [DiscoveryComponent],
})
export class DiscoveryStandaloneComponent implements OnInit {
    private SEOService = inject(SEOService);
    private configurationHandlerService = inject(ConfigurationHandlerService);
    private translate = inject(TranslateService);

    ngOnInit() {
        this.changeDocumentTitle();
    }

    changeDocumentTitle() {
        this.translate
            .get('research.search.document.title', {
                value: this.configurationHandlerService.mainInstitutionName(),
            })
            .subscribe((res) => {
                this.SEOService.updateTitle(res);
            });
    }
}
